<kendo-dialog *ngIf="show()"
              class="isg-dialog-editor"
              [height]="600"
              [width]="400"
              [title]="heading()"
              (close)="onCancel()">

  <div kendoDialogBody>

    <p>{{description()}}</p>

    <app-user-list #userList
                   [showToolbar]="true"
                   [companyId]="filterCompanyId()"
                   [companyIdWithExternals]="filterCompanyIdWithExternals()"
                   [companyIdExternalsOnly]="filterCompanyIdExternalsOnly()"
                   [filterUserGroupCode]="filterUserGroupCode()"
                   [filterAuthAppCode]="filterAuthAppCode()"
                   [showCheckbox]="true"
                   [initialized]="true"
                   [showLicenseUsersOnly]="true"
                   [heightControl]="416"
                   [checkedIds]="userCheckedIds()">

    </app-user-list>

  </div>

  <kendo-dialog-actions>

    <button kendoButton
            themeColor="primary"
            (click)="onClose($event)">
      Ok
    </button>
    <button kendoButton (click)="onCancel()">Cancel</button>

  </kendo-dialog-actions>

</kendo-dialog>
